import { render, staticRenderFns } from "./CompetitionAdd.vue?vue&type=template&id=6a7ac30a&scoped=true&"
import script from "./CompetitionAdd.vue?vue&type=script&lang=ts&"
export * from "./CompetitionAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7ac30a",
  null
  
)

export default component.exports